import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export default function MyTestSeries() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/student/my-products").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-6">My Test Series</h1>
      {items.length === 0 ? (
        <div className="card-surface p-8 text-center">
          <p className="text-content-secondary text-sm mb-4">No test series yet.</p>
          <Link to="/pricing" className="btn-ember rounded-full px-5 py-2 text-sm inline-block">Browse test series</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((p) => (
            <Link key={p.id} to={`/student/series/${p.id}`} className="card-surface p-5 hover:border-ember/60" data-testid={`my-series-${p.id}`}>
              <div className="text-xs text-ember uppercase tracking-wider">{p.type}</div>
              <div className="font-heading font-semibold text-sm mt-1.5 leading-snug">{p.name}</div>
              <div className="text-xs text-content-muted mt-3">{p.num_tests}+ tests • {p.access?.expired ? <span className="text-red-400">Expired</span> : "Active"}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
